export default __webpack_public_path__ + "static/media/protocol_functions.9f94d6b7.png";